// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__3f3ir","rootSuccess":"CompleteLink_rootSuccess__1myc1","rootFailure":"CompleteLink_rootFailure__haZLS","isDisabled":"CompleteLink_isDisabled__2ybff"};